import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
var HIGHLIGHT_START_TAG = '@@@hl@@@';
var HIGHLIGHT_END_TAG = '@@@endhl@@@';
var highlightRE = new RegExp("".concat(HIGHLIGHT_START_TAG, "(.*?)").concat(HIGHLIGHT_END_TAG, ".*"));
var openingTagRE = new RegExp("(.*?)".concat(HIGHLIGHT_START_TAG));
export var enrichResultTitle = function enrichResultTitle(title) {
  var enrichedTitle = [];
  // counter added to maintain uniqueness of element key
  // during subsequent rerenders due to query changes
  var counter = 0;
  if (!title.match(highlightRE)) {
    // if there are no matches then return the title as is
    return /*#__PURE__*/React.createElement("span", {
      key: title + counter
    }, title);
  }
  while (title) {
    var _ref = title.match(openingTagRE) || [],
      _ref2 = _slicedToArray(_ref, 2),
      preMatch = _ref2[0],
      preText = _ref2[1];
    title = title.replace(preText, '');
    if (preText !== '') {
      enrichedTitle.push( /*#__PURE__*/React.createElement("span", {
        key: preText + counter
      }, preText));
    }
    var _ref3 = title.match(highlightRE) || [],
      _ref4 = _slicedToArray(_ref3, 2),
      boldMatch = _ref4[0],
      highlightText = _ref4[1];
    title = title.replace("".concat(HIGHLIGHT_START_TAG).concat(highlightText).concat(HIGHLIGHT_END_TAG), '');
    if (highlightText !== '') {
      enrichedTitle.push( /*#__PURE__*/React.createElement("strong", {
        key: highlightText + counter
      }, highlightText));
    }
    if (preMatch === undefined && boldMatch === undefined) {
      if (title !== '') {
        enrichedTitle.push( /*#__PURE__*/React.createElement("span", {
          key: title + counter
        }, title));
      }
      break;
    }
    counter++;
  }
  return enrichedTitle;
};